import { render, staticRenderFns } from "./SentimentScale.vue?vue&type=template&id=104d5a8a&scoped=true"
import script from "./SentimentScale.vue?vue&type=script&lang=js"
export * from "./SentimentScale.vue?vue&type=script&lang=js"
import style0 from "./SentimentScale.vue?vue&type=style&index=0&id=104d5a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104d5a8a",
  null
  
)

export default component.exports